module.exports = __webpack_public_path__ + "img/block3_visits.bf85bd76.png";